<mat-dialog-content class="dialog-container row">
  <table>
    <thead>
      <th>{{ data.column.Label }}</th>
    </thead>
    <tbody>
      @for (
        dataValue of data.dataItem[data.column.DataField];
        let i = $index;
        track dataValue
      ) {
        <tr>
          <td>
            @if (
              data.column.AllowDecrypt &&
              data.dataItem[data.column.DecryptTarget][i]
            ) {
              <div class="decrypt-field">
                {{ dataValue }}
                <button
                  type="button"
                  class="ms-2"
                  mat-icon-button
                  color="primary"
                  matTooltip="Click to copy raw value"
                  matTooltipPosition="below"
                  [matTooltipShowDelay]="500"
                  (click)="
                    decryptValue(data.dataItem[data.column.DecryptTarget][i])
                  "
                >
                  <mat-icon>lock_open</mat-icon>
                </button>
              </div>
            } @else {
              {{ dataValue }}
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions class="row buttons">
  <button type="button" mat-raised-button (click)="cancel()">Close</button>
</mat-dialog-actions>
